import React, { FC } from 'react';
import { AssessmentPortalApp } from '../assessment-portal';
import { adhdQuestionnaireConfig } from './config/adhd-questionnaire-config';

const AdhdQuestionnairePortalApp: FC = () => (
  <AssessmentPortalApp config={adhdQuestionnaireConfig} />
);

export default AdhdQuestionnairePortalApp;
